import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Table/sgds-table";
import { register } from "../../utils/ce-registry";

register("sgds-table", Component);

export default createComponent({
  react: React,
  tagName: "sgds-table",
  elementClass: Component,
  events: {}
});
